<div class='zip-form-container' #zipform>
  @if (entry.base?.display) {
    <div class='maxWidth350'>
      <ptl-zip-code-and-county-select
        [preloadedValues]="preloadedValues"
        [showStateField]="true"
        [ignoreCookieUpdates]="true"
        (zipAndCountyChanged)="zipCountyChanged($event)" >
      </ptl-zip-code-and-county-select>
    </div>
  }
</div>